
import { Component } from 'react'

import { ExpectationQuestionnaire } from '../../../../../lib/Questionnaires'
import {
  YesNoRadioOptions,
  bindTargetMixin,
  CancelButton,
  CheckboxInput,
  QuestionRadioButtonInput,
  SaveButton
} from '../../../../shared/FormBuilder'

const renderQuestions = () => {
  const questionConfig = [
    {
      type: 'T1',
      title: 'Patient Perspective'
    },
    {
      type: 'RB',
      question: ExpectationQuestionnaire.history.question,
      name: ExpectationQuestionnaire.history.name,
      radioButtons: YesNoRadioOptions
    },
    {
      type: 'RB',
      question: ExpectationQuestionnaire.understandMedical.question,
      name: ExpectationQuestionnaire.understandMedical.name,
      radioButtons: YesNoRadioOptions
    },
    {
      type: 'RB',
      question: ExpectationQuestionnaire.understandTreatment.question,
      name: ExpectationQuestionnaire.understandTreatment.name,
      radioButtons: YesNoRadioOptions
    },
    {
      type: 'RB',
      question: ExpectationQuestionnaire.happyWithCare.question,
      name: ExpectationQuestionnaire.happyWithCare.name,
      radioButtons: YesNoRadioOptions
    },
    {
      type: 'T',
      title: 'Clinical Perspective'
    },
    {
      type: 'RB',
      question: ExpectationQuestionnaire.realisticPrognosis.question,
      name: ExpectationQuestionnaire.realisticPrognosis.name,
      radioButtons: YesNoRadioOptions
    },
    {
      type: 'RB',
      question: ExpectationQuestionnaire.realisticTreatment.question,
      name: ExpectationQuestionnaire.realisticTreatment.name,
      radioButtons: YesNoRadioOptions
    },
    {
      type: 'RB',
      question: ExpectationQuestionnaire.realisticSymptoms.question,
      name: ExpectationQuestionnaire.realisticSymptoms.name,
      radioButtons: YesNoRadioOptions
    },
    {
      type: 'RB',
      question: ExpectationQuestionnaire.copingSkills.question,
      name: ExpectationQuestionnaire.copingSkills.name,
      radioButtons: YesNoRadioOptions
    },
    {
      type: 'T',
      title: 'Long Term Care'
    },
    {
      type: 'RB',
      question: ExpectationQuestionnaire.longTerm.question,
      name: ExpectationQuestionnaire.longTerm.name,
      radioButtons: YesNoRadioOptions
    },
    {
      type: 'CB'
    },
    {
      type: 'RB',
      question: ExpectationQuestionnaire.understandHospice.question,
      name: ExpectationQuestionnaire.understandHospice.name,
      radioButtons: YesNoRadioOptions
    },
    {
      type: 'RB',
      question: ExpectationQuestionnaire.arrangedFuneral.question,
      name: ExpectationQuestionnaire.arrangedFuneral.name,
      radioButtons: YesNoRadioOptions
    },
    {
      type: 'RB',
      question: ExpectationQuestionnaire.arrangedFuneralHelp.question,
      name: ExpectationQuestionnaire.arrangedFuneralHelp.name,
      radioButtons: YesNoRadioOptions
    }
  ]

  return questionConfig.map((q, index) => {
    if (q.type === 'T1') {
      return (
        <div
          key={`ExpectationsTitle${index}`}
          className='row'
        >
          <h2 className='col-xs-12'>{q.title}</h2>
        </div>
      )
    }
    if (q.type === 'T') {
      return (
        <div
          key={`ExpectationsTitle${index}`}
          className='row margin-top'
        >
          <h2 className='col-xs-12'>{q.title}</h2>
        </div>
      )
    }
    if (q.type === 'CB') {
      return (
        <div
          key={`ExpectationsCB${index}`}
          className='row nh-margin-top-2 nh-margin-bottom-2'
        >
          <div className='col-xs-3'>
            <CheckboxInput {...ExpectationQuestionnaire.housing} />
          </div>
          <div className='col-xs-3'>
            <CheckboxInput {...ExpectationQuestionnaire.SNF} />
          </div>
          <div className='col-xs-3'>
            <CheckboxInput {...ExpectationQuestionnaire.DME} />
          </div>
          <div className='col-xs-3'>
            <CheckboxInput {...ExpectationQuestionnaire.sitters} />
          </div>
        </div>
      )
    }
    if (q.type === 'RB') {
      return (
        <div className='col-xs-12'>
          <QuestionRadioButtonInput
            key={`ExpectationsRB${index}`}
            question={q.question}
            name={q.name}
            radioButtons={q.radioButtons}
          />
        </div>
      )
    }
    return null
  })
}

class ExpectationsForm extends bindTargetMixin(Component) {
  constructor (props) {
    super(props)
    this.state = {
      value: props.initialValues
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.getValues = this.getValues.bind(this)
  }

  getValues () {
    return { ...this.state.value }
  }

  handleSubmit () {
    const { onSubmit } = this.props
    onSubmit(this.getValues())
  }

  render () {
    const { onCancel } = this.props
    return (
      <form>
        {renderQuestions()}
        <div className='row end-xs margin-top'>
          <div className='col-xs-offset-8 col-xs-4'>
            <CancelButton onClick={onCancel} />
            <SaveButton onClick={this.handleSubmit} />
          </div>
        </div>
      </form>
    )
  }
}

export default ExpectationsForm
